export const ShStyle: any = {
    center: { alignItems: "center" },
    content: {
        display: "flex",
        height: "90vh",
        flexDirection: "column",
        justifyContent: "space-evenly",
        margin: "32px",
    },
}